export const IpagCardBrands = new Map();
IpagCardBrands.set("visa", "Visa");
IpagCardBrands.set("mastercard", "Master Card");
IpagCardBrands.set("elo", "Elo");
IpagCardBrands.set("amex", "American Express");
IpagCardBrands.set("diners", "Dinners");
IpagCardBrands.set("discover", "Discover");
IpagCardBrands.set("hipercard", "Hiper Card");
IpagCardBrands.set("hiper", "Hiper Itaú");
IpagCardBrands.set("jcb", "JCB");
IpagCardBrands.set("aura", "Aura");